import { render, staticRenderFns } from "./ThuxSpinner.vue?vue&type=template&id=71af848a&"
import script from "./ThuxSpinner.vue?vue&type=script&lang=js&"
export * from "./ThuxSpinner.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports